import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root',
})
export class ExportService {
    exportToCsv(blob: any, fileName: string = "data.csv"): void {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    }

    exportToCsvNew(data: any[], fileName: string = "data.csv"): void {
        const headers = Object.keys(data[0]);
        const csv = data.map((row) =>
            headers
            .map((fieldName) => JSON.stringify(row[fieldName]))
            .join(',')
        );
        csv.unshift(headers.join(','));
        const csvArray = csv.join('\r\n');

        const a = document.createElement('a');
        const blob = new Blob([csvArray], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);

        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
    }
}